/**
 * Wave 24C — mobile PLP infinite scroll / load-more for collection + search.
 * Uses Section Rendering API (?page=N&section_id=…) and appends product cards.
 * Prestige pagination UI is hidden on mobile via eros-plp-parity.css.
 */
(function () {
  var MQ = window.matchMedia('(max-width: 699px)');
  var LOADING = false;
  var DONE = false;
  var NEXT_PAGE = null;
  var SECTION_ID = null;
  var PRODUCT_LIST = null;
  var SENTINEL = null;
  var OBSERVER = null;
  var STATUS_EL = null;

  function activeRoot() {
    return (
      document.querySelector('.shopify-section--main-collection') ||
      document.querySelector('.shopify-section--main-search')
    );
  }

  function findProductList(root) {
    return (
      root.querySelector('product-list.product-list') ||
      root.querySelector('.product-list:not(.product-list--carousel)')
    );
  }

  function findPagination(root) {
    return root.querySelector('.collection__main .pagination, .main-search .pagination, .pagination');
  }

  function resolveSectionId(root) {
    var id = root.id || '';
    var m = id.match(/^shopify-section-(.+)$/);
    if (m && m[1]) return m[1];
    // templates/collection.json + search.json use key "main"
    return 'main';
  }

  function nextPageFromPagination(nav) {
    if (!nav) return null;
    var next = nav.querySelector('a[rel="next"]');
    if (!next) return null;
    try {
      var url = new URL(next.href, window.location.origin);
      var page = parseInt(url.searchParams.get('page') || '', 10);
      return Number.isFinite(page) && page > 1 ? page : null;
    } catch (e) {
      return null;
    }
  }

  function ensureStatus(root) {
    if (STATUS_EL && STATUS_EL.isConnected) return STATUS_EL;
    var host =
      root.querySelector('.collection__main') ||
      root.querySelector('.main-search__results') ||
      findProductList(root) ||
      root;
    STATUS_EL = document.createElement('div');
    STATUS_EL.className = 'eros-plp-infinite__status';
    STATUS_EL.setAttribute('aria-live', 'polite');
    STATUS_EL.hidden = true;
    host.appendChild(STATUS_EL);
    return STATUS_EL;
  }

  function ensureSentinel(root) {
    if (SENTINEL && SENTINEL.isConnected) return SENTINEL;
    var host =
      root.querySelector('.collection__main') ||
      root.querySelector('.main-search__results') ||
      findProductList(root) ||
      root;
    SENTINEL = document.createElement('div');
    SENTINEL.className = 'eros-plp-infinite__sentinel';
    SENTINEL.setAttribute('aria-hidden', 'true');
    host.appendChild(SENTINEL);
    return SENTINEL;
  }

  function setStatus(text, busy) {
    if (!STATUS_EL) return;
    if (!text) {
      STATUS_EL.hidden = true;
      STATUS_EL.textContent = '';
      return;
    }
    STATUS_EL.hidden = false;
    STATUS_EL.textContent = text;
    STATUS_EL.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function buildSectionUrl(page) {
    var url = new URL(window.location.href);
    url.searchParams.set('page', String(page));
    url.searchParams.set('section_id', SECTION_ID);
    return url.toString();
  }

  function appendCards(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var remoteList =
      doc.querySelector('product-list.product-list') ||
      doc.querySelector('.product-list:not(.product-list--carousel)');
    if (!remoteList || !PRODUCT_LIST) return { appended: 0, next: null };

    var nodes = Array.prototype.slice.call(remoteList.children);
    var appendedNodes = [];
    nodes.forEach(function (node) {
      if (!(node instanceof HTMLElement)) return;
      // Skip promo / empty fragments without product identity when possible
      appendedNodes.push(PRODUCT_LIST.appendChild(document.importNode(node, true)));
    });

    if (appendedNodes.length) {
      // eros-plp-quick-add.js (and anything else that binds per-card
      // controls) only (re)binds on DOMContentLoaded, shopify:section:load,
      // or this event — appendChild alone leaves the quick-add "+" button
      // on every infinite-scroll-loaded card with no click listener at
      // all, a silent no-op on tap. Confirmed live 2026-08-09.
      appendedNodes.forEach(function (node) {
        document.dispatchEvent(new CustomEvent('eros:content-loaded', { detail: { root: node } }));
      });
    }

    var remoteNav = doc.querySelector('.pagination');
    var next = nextPageFromPagination(remoteNav);
    return { appended: appendedNodes.length, next: next };
  }

  function loadNext() {
    if (!MQ.matches || LOADING || DONE || !NEXT_PAGE || !PRODUCT_LIST) return;
    LOADING = true;
    setStatus('…', true);

    fetch(buildSectionUrl(NEXT_PAGE), {
      headers: { Accept: 'text/html' },
      credentials: 'same-origin',
    })
      .then(function (res) {
        if (!res.ok) throw new Error('http_' + res.status);
        return res.text();
      })
      .then(function (html) {
        var result = appendCards(html);
        if (!result.appended || !result.next) {
          DONE = true;
          NEXT_PAGE = null;
          setStatus('');
          if (OBSERVER && SENTINEL) OBSERVER.unobserve(SENTINEL);
          return;
        }
        NEXT_PAGE = result.next;
        setStatus('');
      })
      .catch(function () {
        setStatus('!');
        // Allow retry on next intersection / click
      })
      .finally(function () {
        LOADING = false;
      });
  }

  function bindObserver(root) {
    if (OBSERVER) OBSERVER.disconnect();
    ensureSentinel(root);
    ensureStatus(root);
    OBSERVER = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNext();
        });
      },
      { rootMargin: '320px 0px' },
    );
    OBSERVER.observe(SENTINEL);

    // Tap fallback if auto-load fails once
    SENTINEL.addEventListener('click', loadNext);
  }

  function init() {
    if (!MQ.matches) return;
    var root = activeRoot();
    if (!root) return;

    PRODUCT_LIST = findProductList(root);
    if (!PRODUCT_LIST) return;

    SECTION_ID = resolveSectionId(root);
    var nav = findPagination(root);
    NEXT_PAGE = nextPageFromPagination(nav);
    DONE = !NEXT_PAGE;
    if (DONE) return;

    bindObserver(root);
  }

  function onFacetOrNavigate() {
    // Prestige facet-link replaces section HTML — re-bind after settle.
    // shopify:section:load is a native Shopify event that in practice only
    // fires inside the theme editor's live preview (confirmed — nothing in
    // this theme dispatches it manually); still guard the reset so it's a
    // no-op unless PRODUCT_LIST was actually replaced/detached, instead of
    // unconditionally wiping in-flight infinite-scroll state (which would
    // re-derive NEXT_PAGE from the still-stale SSR pagination nav and
    // re-append already-loaded pages).
    window.setTimeout(function () {
      if (PRODUCT_LIST && PRODUCT_LIST.isConnected) return;
      LOADING = false;
      DONE = false;
      NEXT_PAGE = null;
      PRODUCT_LIST = null;
      SENTINEL = null;
      STATUS_EL = null;
      if (OBSERVER) {
        OBSERVER.disconnect();
        OBSERVER = null;
      }
      init();
    }, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  MQ.addEventListener('change', function () {
    if (MQ.matches) init();
  });

  document.addEventListener('facet:update', onFacetOrNavigate);
  document.addEventListener('shopify:section:load', onFacetOrNavigate);
})();
